module.exports = __webpack_public_path__ + "img/remix-03.ef456814.png";